<template>
    <div class="page page--act" ref="page">
        <clp-dialog :show="this.bool.showDialog" tablet="white">
            <makc-alert v-show="this.str.dialogType === 'server_fail'"
                @closeDialog="this.bool.showDialog = false"
            >
            </makc-alert>
            <makc-alert v-show="this.str.dialogType === 'loader'"
                type="loader"
                title="Пожалуйста, подождите"
            >
            </makc-alert>
            <descr-alert v-show="this.str.dialogType === 'descr_error'"
                :show-back-btn="false"
                :descr="this.str.descrErrorText"
            >
            </descr-alert>
        </clp-dialog>

        <div class="container container--act" style="margin-top: 40px">
            <!-- Перевод в оплачено -->
            <div class="content content--act">
                <div @click="sendPost" class="content__title text-sb text-giant text-mob-lg mb30 mob-mb10">Перевод в оплачено</div>
                <!-- Расчет -->
                <div class="content__subtitle text-lg text-mob-med mb20 mob-mb10">Расчет</div>
                <section class="content__section content__section--calc section section--makc">
                    <!-- Инпуты -->
                    <div class="inputs inputs--makc mb0">
                        <ul class="inputs__list">
                            <!-- Номер полиса  -->
                            <li class="inputs__item inputs__item--1-of-3 inputs__item--tablet-full" >
                                <div class="clp-input clp-input--makc">
                                    <label class="clp-input__label" for="policy_number">Номер полиса</label>        
                                    <input v-model="this.obj.fields.policy_number" class="clp-input__control" type="text" id="policy_number" placeholder="Номер полиса" />
                                    <label v-if="this.arr.errors[0] === 'policy_number' && this.bool.showErrors" class="clp-input__error" for="policy_number" >{{ this.arr.errors[1] }}</label>
                                </div>
                            </li>
                            <!-- Оплачено лет -->
                            <li class="inputs__item inputs__item--1-of-3 inputs__item--tablet-full" >
                                <div class="clp-input clp-input--makc">
                                    <label class="clp-input__label" for="change_year">Оплачено лет</label>        
                                    <input v-model="this.obj.fields.change_year" class="clp-input__control" type="text" id="change_year" placeholder="Оплачено лет" />
                                    <label v-if="this.arr.errors[0] === 'change_year' && this.bool.showErrors" class="clp-input__error" for="change_year" >{{ this.arr.errors[1] }}</label>
                                </div>
                            </li>
                            <!-- Новый размер премии -->
                            <li class="inputs__item inputs__item--1-of-3 inputs__item--tablet-full" >
                                <div class="clp-input clp-input--makc">
                                    <label class="clp-input__label" for="new_prem">Новый размер премии</label>        
                                    <input v-model="this.obj.fields.new_prem" class="clp-input__control" type="text" id="new_prem" placeholder="Новый размер премии" />
                                    <label v-if="this.arr.errors[0] === 'new_prem' && this.bool.showErrors" class="clp-input__error" for="new_prem" >{{ this.arr.errors[1] }}</label>
                                </div>
                            </li>
                        </ul>
                    </div>
                    <!-- Корректировать кешбэк -->
                    <div class="section__checkboxes checkboxes mb30 mob-mb20">
                        <ul class="checkboxes__list">
                            <ul class="checkboxes__list">
                                <li class="checkboxes__item">
                                    <div class="checkbox checkbox--makc">
                                        <input v-model="this.bool.adjust_dpe" class="checkbox__input" type="checkbox" name="adjust_dpe" value="adjust_dpe" id="adjust_dpe">
                                        <label class="checkbox__label" for="adjust_dpe">
                                            <span class="checkbox__label--icon"><img class="icon" src="@/create/assets/icons/check.svg"></span>
                                            <span class="checkbox__label--text">
                                                Корректировать кешбэк
                                            </span>
                                        </label>
                                    </div>
                                </li>
                            </ul>
                        </ul>
                    </div>
                    <!-- Рассчитать -->
                    <div class="section__buttons section__buttons--create-contract">
                        <button @click="this.bool.showIndicatorAlert = !this.bool.showIndicatorAlert" class="section__button button button--makc button--makc-blue button--makc-smaller">
                            Рассчитать
                        </button>
                    </div>
                    <div v-show="this.bool.showIndicatorAlert" class="section__indicator">
                        <div class="section__indicator-alert text-mid text-mob-smer">
                            Страховая премия по&nbsp;договору страхования не&nbsp;может превышать 40&nbsp;000&nbsp;рублей. 
                            Пожалуйста, разделите список застрахованных лиц на&nbsp;несколько договоров, 
                            страховая премия по&nbsp;каждому из&nbsp;которых не&nbsp;будет превышать 40&nbsp;000&nbsp;рублей.
                        </div>
                    </div>
                </section>
                <!-- Результаты -->
                <div class="content__subtitle text-lg text-mob-med mb20 mob-mb10">Результаты</div>
                <section class="content__section content__section--results section section--makc">
                    <!-- Минимум -->
                    <div class="wrapper--bordered">
                        <h3 class="section__title text-med text-mob-mid mb10">Минимум</h3>
                        <!-- Риски -->
                        <div class="section__buttons section__buttons--create-contract mb20">
                            <button @click="this.bool.showMin1 = !this.bool.showMin1" class="section__button button button--makc button--makc-unfilled button--makc-small">
                                {{ this.bool.showMin1 ? 'Cкрыть' : 'Риски' }}
                            </button>
                        </div>
                        <div v-show="this.bool.showMin1" class="table">
                            <div class="table__heads">
                                <div class="table__head table__head--wide">PRODUCT_ID: 457457547</div>
                            </div>
                            <div class="table__heads">
                                <div class="table__head">risk_id</div>
                                <div class="table__head">Netto</div>
                                <div class="table__head">Brutto</div>
                                <div class="table__head">Amount</div>
                                <div class="table__head">Premia</div>
                            </div>
                            <div class="table__items">
                                <div v-for="item in 10" class="table__item">
                                    <div class="table__item-data">11021</div>
                                    <div class="table__item-data">0.1602994579823365</div>
                                    <div class="table__item-data">0.1661115633628312</div>
                                    <div class="table__item-data">1830000.0</div>
                                    <div class="table__item-data">303984.16</div>
                                </div>
                            </div>
                        </div>
                        <!-- Выкупные суммы -->
                        <div class="section__buttons section__buttons--create-contract mb20">
                            <button @click="this.bool.showMin2 = !this.bool.showMin2" class="section__button button button--makc button--makc-unfilled button--makc-small">
                                {{ this.bool.showMin2 ? 'Cкрыть' : 'Выкупные суммы' }}
                            </button>
                        </div>
                        <div v-show="this.bool.showMin2" class="table">
                            <div class="table__heads">
                                <div class="table__head table__head--1-of-3">pol_year</div>
                                <div class="table__head table__head--1-of-3">pol_quarter</div>
                                <div class="table__head table__head--1-of-3">SV</div>
                            </div>
                            <div class="table__items">
                                <div v-for="item in 10" class="table__item">
                                    <div class="table__item-data table__item-data--1-of-3">11021</div>
                                    <div class="table__item-data table__item-data--1-of-3">0.1602994579823365</div>
                                    <div class="table__item-data table__item-data--1-of-3">0.1661115633628312</div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- Максимум -->
                    <div class="wrapper--bordered">
                        <h3 class="section__title text-med text-mob-mid mb10">Максимум</h3>
                        <!-- Риски -->
                        <div class="section__buttons section__buttons--create-contract mb20">
                            <button @click="this.bool.showMax1 = !this.bool.showMax1" class="section__button button button--makc button--makc-unfilled button--makc-small">
                                {{ this.bool.showMax1 ? 'Cкрыть' : 'Риски' }}
                            </button>
                        </div>
                        <div v-show="this.bool.showMax1" class="table">
                            <div class="table__heads">
                                <div class="table__head table__head--wide">PRODUCT_ID: 457457547</div>
                            </div>
                            <div class="table__heads">
                                <div class="table__head">risk_id</div>
                                <div class="table__head">Netto</div>
                                <div class="table__head">Brutto</div>
                                <div class="table__head">Amount</div>
                                <div class="table__head">Premia</div>
                            </div>
                            <div class="table__items">
                                <div v-for="item in 10" class="table__item">
                                    <div class="table__item-data">11021</div>
                                    <div class="table__item-data">0.1602994579823365</div>
                                    <div class="table__item-data">0.1661115633628312</div>
                                    <div class="table__item-data">1830000.0</div>
                                    <div class="table__item-data">303984.16</div>
                                </div>
                            </div>
                        </div>
                        <!-- Выкупные суммы -->
                        <div class="section__buttons section__buttons--create-contract mb20">
                            <button @click="this.bool.showMax2 = !this.bool.showMax2" class="section__button button button--makc button--makc-unfilled button--makc-small">
                                {{ this.bool.showMax2 ? 'Cкрыть' : 'Выкупные суммы' }}
                            </button>
                        </div>
                        <div v-show="this.bool.showMax2" class="table">
                            <div class="table__heads">
                                <div class="table__head table__head--1-of-3">pol_year</div>
                                <div class="table__head table__head--1-of-3">pol_quarter</div>
                                <div class="table__head table__head--1-of-3">SV</div>
                            </div>
                            <div class="table__items">
                                <div v-for="item in 10" class="table__item">
                                    <div class="table__item-data table__item-data--1-of-3">11021</div>
                                    <div class="table__item-data table__item-data--1-of-3">0.1602994579823365</div>
                                    <div class="table__item-data table__item-data--1-of-3">0.1661115633628312</div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- 3 раздел -->
                    <div class="wrapper--bordered">
                        <h3 class="section__title text-med text-mob-mid mb30 mob-mb20">3 раздел</h3>
                        <!-- Поля -->
                        <div class="inputs inputs--makc mb0">
                            <ul class="inputs__list">
                                <!-- K main  -->
                                <li class="inputs__item inputs__item--1-of-4 inputs__item--tablet-1-of-2" >
                                    <div class="clp-input clp-input--makc">
                                        <label class="clp-input__label" for="k_main">K main</label>        
                                        <input v-model="this.obj.fields.k_main" class="clp-input__control" type="text" id="k_main" placeholder="K main" />
                                        <label v-if="this.arr.errors[0] === 'k_main' && this.bool.showErrors" class="clp-input__error" for="k_main" >{{ this.arr.errors[1] }}</label>
                                    </div>
                                </li>
                                <!-- K DPE -->
                                <li class="inputs__item inputs__item--1-of-4 inputs__item--tablet-1-of-2" >
                                    <div class="clp-input clp-input--makc">
                                        <label class="clp-input__label" for="k_dpe">K DPE</label>        
                                        <input v-model="this.obj.fields.k_dpe" class="clp-input__control" type="text" id="k_dpe" placeholder="K DPE" />
                                        <label v-if="this.arr.errors[0] === 'k_dpe' && this.bool.showErrors" class="clp-input__error" for="k_dpe" >{{ this.arr.errors[1] }}</label>
                                    </div>
                                </li>
                            </ul>
                        </div>
                        <!-- Рассчитать -->
                        <div class="section__buttons section__buttons--create-contract">
                            <button class="section__button button button--makc button--makc-blue button--makc-smaller">
                                Рассчитать
                            </button>
                        </div>
                    </div>
                </section>
            </div>
        </div>
    </div>
</template>
<script>
import ClpDialog from "@/create/components/ClpDialog.vue";
import MakcAlert from "@/create/components/MakcAlert.vue";
import DescrAlert from "@/create/components/DescrAlert.vue";
import ThirdComplete from "@/create/components/ThirdComplete.vue";
import ClpNumbers from "@/create/components/ClpNumbers.vue";
import axios from "axios";
import {localDevelopment, baseURL} from "@/create/composables/const";
export default {
    components: { ClpDialog, MakcAlert, DescrAlert, ThirdComplete, ClpNumbers },
    data() {
        return {
            bool: {
                showDialog: false,
                // showDialog: true,
                showErrors: false,
                // showIndicatorAlert: true,
                showIndicatorAlert: false,
                showMin1: false,
                showMin2: false,
                showMax1: false,
                showMax2: false,
                // fieldsAreValidated: false,
                // blockRequest: false,
                adjust_dpe: false,
            },
            str: {
                // sessionToken: "",
                dialogType: "server_fail",
                // dialogType: 'loader',
                // dialogType: 'descr_error',
                descrErrorText: "",
            },
            arr: {
                errors: [],
            },
            obj: {
                fields: {
                    policy_number: "",
                    change_year: "",
                    new_prem: "0",
                    k_main: "",
                    k_dpe: ""
                },
            },
        };
    },
    methods: {
        // запросы
        async sendPost() {
            try {
                console.log("getDataBySlug request");

                // const url = "https://" + window.location.host + "/create/app.php";
                const url = "http://test5.makclife.ru:4001/MM/MM.php";
                let request = {
                    l1: "x",
                    l2: "y",
                    l3: "i",
                };

                const response = await axios.post(url, request);
                // const r_data = JSON.parse(response.data);
                const r_data = response.data;
                console.log("r_data");
                console.log(r_data);

                // if (!r_data) {
                //     this.openDialog();
                //     console.log("backend error after getDataBySlug request");
                //     return;
                // }

                const ins_con = {
                    pol: {
                        cid: 100008,
                        cover_id: 10,
                        ser: 'RSB',
                        num: 80909,
                        sa: 330000,
                        prem: 70000
                    },
                    risk: {
                        r_id1: {
                            rid: 11021,
                            sa: 330000.0,
                            p: 0.1698128451444483,
                            g: 0.1757315731683921,
                            prem: 57991.42,
                            tag: 1
                        },
                        r_id2: {
                            rid: 11042,
                            sa: 13200.0,
                            p: 0.21507108732447,
                            g: 0.22231852023579,
                            prem: 2934.6,
                            tag: 1
                        },
                        r_id3: {
                            rid: 11042,
                            sa: 12000.0,
                            p: 0.19879407121045,
                            g: 0.20549300369919,
                            prem: 2465.92,
                            tag: 2
                        },
                        r_id4: {
                            rid: 11042,
                            sa: 12400.0,
                            p: 0.1957435257053933,
                            g: 0.2025660525296307,
                            prem: 2511.82,
                            tag: 3
                        },
                        r_id5: {
                            rid: 11042,
                            sa: 11800.0,
                            p: 0.181630987027876,
                            g: 0.187961629518578,
                            prem: 2217.95,
                            tag: 4
                        },
                        r_id6: {
                            rid: 11042,
                            sa: 10600.0,
                            p: 0.1692400617723893,
                            g: 0.1751388257647961,
                            prem: 1856.47,
                            tag: 5
                        },
                        r_id7: {
                            rid: 22008,
                            sa: 60000.0,
                            p: 0.000351851851852,
                            g: 0.0003637085022402,
                            prem: 21.82,
                            tag: 1
                        }
                    },
                    surrender: {
                        sv_id1: {
                            y: 1,
                            q: 1,
                            val_indx: 0.0
                        },
                        sv_id2: {
                            y: 1,
                            q: 2,
                            val_indx: 0.0
                        },
                        sv_id3: {
                            y: 1,
                            q: 3,
                            val_indx: 0.0
                        },
                        sv_id4: {
                            y: 1,
                            q: 4,
                            val_indx: 0.0
                        },
                        sv_id5: {
                            y: 2,
                            q: 1,
                            val_indx: 0.0
                        },
                        sv_id6: {
                            y: 2,
                            q: 2,
                            val_indx: 0.0
                        },
                        sv_id7: {
                            y: 2,
                            q: 3,
                            val_indx: 0.0
                        },
                        sv_id8: {
                            y: 2,
                            q: 4,
                            val_indx: 0.0
                        },
                        sv_id9: {
                            y: 3,
                            q: 1,
                            val_indx: 43485.2
                        },
                        sv_id10: {
                            y: 3,
                            q: 2,
                            val_indx: 44027.5
                        },
                        sv_id11: {
                            y: 3,
                            q: 3,
                            val_indx: 44569.8
                        },
                        sv_id12: {
                            y: 3,
                            q: 4,
                            val_indx: 45112.1
                        },
                        sv_id13: {
                            y: 4,
                            q: 1,
                            val_indx: 90899.6
                        },
                        sv_id14: {
                            y: 4,
                            q: 2,
                            val_indx: 92033.7
                        },
                        sv_id15: {
                            y: 4,
                            q: 3,
                            val_indx: 93168.9
                        },
                        sv_id16: {
                            y: 4,
                            q: 4,
                            val_indx: 94304.1
                        },
                        sv_id17: {
                            y: 5,
                            q: 1,
                            val_indx: 157142.7
                        },
                        sv_id18: {
                            y: 5,
                            q: 2,
                            val_indx: 159107.3
                        },
                        sv_id19: {
                            y: 5,
                            q: 3,
                            val_indx: 161071.9
                        },
                        sv_id20: {
                            y: 5,
                            q: 4,
                            val_indx: 163035.4
                        }
                    }
                }


            } catch (e) {
                console.log("Frontend Error - " + e);
            } finally {
                setTimeout(() => {
                    this.bool.blockRequest = false;
                }, 2000);
            }
        },
        async getDataBySlug() {
            if (this.bool.blockRequest) return;
            try {
                this.bool.blockRequest = true;
                console.log("getDataBySlug request");
                let request = {
                    action: "get_policy_data",
                    format: "json",
                    object: "statement",
                    login: "sravni",
                    slug: this.str.slug,
                };

                const response = await axios.post(baseURL, request);

                // const r_data = JSON.parse(response.data);
                const r_data = response.data;

                  
                const data = {
                    r: {
                        345765246: {
                            risk_id: '11021',
                            amount: '1830000.0',
                            netto: '0.1602994579823365',
                            brutto: '0.1661115633628312',
                            premia: '303984.16',
                        },
                        2: {
                            risk_id: '11021',
                            amount: '1830000.0',
                            netto: '0.1602994579823365',
                            brutto: '0.1661115633628312',
                            premia: '303984.16',
                        },
                        3: {
                            risk_id: '11021',
                            amount: '1830000.0',
                            netto: '0.1602994579823365',
                            brutto: '0.1661115633628312',
                            premia: '303984.16',
                        }
                    },
                    sv: { 
                        1: {
                            pol_year: '1',
                            pol_quarter: '1',
                            sv: '0.0',
                        },
                        2: {
                            pol_year: '1',
                            pol_quarter: '1',
                            sv: '0.0',
                        },
                        3: {
                            pol_year: '1',
                            pol_quarter: '1',
                            sv: '0.0',
                        }
                    },
                    ppj: {
                        a: '',
                        b: [
                            'x', 'y', 'z'
                        ]
                    }
                };  
                console.log("r_data");
                console.log(r_data);

                if (!r_data) {
                    this.openDialog();
                    console.log("backend error after getDataBySlug request");
                    return;
                }

                this.obj.data.reduction_amount = r_data.amount;
                this.obj.data.policy_number = r_data.policy;
                this.obj.data.name = r_data.first_name;
                this.obj.data.surname = r_data.last_name;
                this.obj.data.patronymic = r_data.middle_name;
                this.obj.data.phone = r_data.phone;

                this.obj.data.email = r_data.email;
                this.obj.data.bik = r_data.bic;
                this.obj.data.settlement_account = r_data.rs;
                this.obj.data.bank_name = r_data.NAMEMINI;
                this.obj.data.correspondent_account = r_data.KS;

                if (r_data.error_code == 9007 || r_data.error_code == 9008) {
                    this.bool.agtAlreadySigned = true;
                } else 
                if (r_data.error_code == 9005) {
                    this.bool.agtNotFound = true;
                } else 
                if (r_data.error_code) {
                    this.openDialog('descr_error');

                    const message = r_data.error_desc;
                    this.str.descrErrorText = message;
                    this.bool.showPageContent = false;
                    
                    console.log("backend error after getDataBySlug request");
                    console.log(r_data.error_desc);
                } else 
                if (r_data.error.message) {
                    this.openDialog('descr_error');

                    const message = r_data.error.log_number;
                    this.str.descrErrorText = message;
                    this.bool.showPageContent = false;
                    
                    console.log("backend error after getDataBySlug request");
                    console.log(r_data.error_desc);
                } 
            } catch (e) {
                console.log("Frontend Error - " + e);
            } finally {
                setTimeout(() => {
                    this.bool.blockRequest = false;
                }, 2000);
            }
        },
        // валидация
        // frontValidate() {
        //     this.arr.errors = [];
        //     const cyrillicAndNums =
        //         /^[\u0400-\u04FF\s'\.,-\/#!$%\^&\*;:{}=\-_`~()\d]+$/;
        //     const cyrillic = /^[\u0400-\u04FF\s'\.,-\/#!$%\^&\*;:{}=\-_`~()]+$/;
        //     const latin = /^[A-z\u00C0-\u00ff\s'\.,-\/#!$%\^&\*;:{}=\-_`~()]+$/;
        //     const email = /^\w+\.*\w*@[a-zA-Z_]+?\.[a-zA-Z]{2,3}$/;
        //     // данные Страхователя
        //     if (true) {
        //         if (false) {
        //             return false;
        //         }
        //         // // Номер полиса
        //         // else if (!this.obj.data.policy_number)
        //         // {
        //         //     this.arr.errors.push('policy_number');
        //         //     this.arr.errors.push('укажите номер полиса');
        //         //     return false
        //         // }
        //         // // Фамилия
        //         // else if (!this.obj.data.surname)
        //         // {
        //         //     this.arr.errors.push('surname');
        //         //     this.arr.errors.push('укажите фамилию');
        //         //     return false
        //         // }
        //         // else if (!cyrillic.test(this.obj.data.surname))
        //         // {
        //         //     this.arr.errors.push('surname');
        //         //     this.arr.errors.push('допустимы только символы кириллицы');
        //         //     return false
        //         // }
        //         // // else if (this.obj.data.surname.length < 3)
        //         // // {
        //         // //     this.arr.errors.push('surname');
        //         // //     this.arr.errors.push('укажите как минимум три буквы');
        //         // //     return false
        //         // // }
        //         // // Имя
        //         // else if (!this.obj.data.name)
        //         // {
        //         //     this.arr.errors.push('name');
        //         //     this.arr.errors.push('укажите имя');
        //         //     return false
        //         // }
        //         // else if (!cyrillic.test(this.obj.data.name))
        //         // {
        //         //     this.arr.errors.push('name');
        //         //     this.arr.errors.push('допустимы только символы кириллицы');
        //         //     return false
        //         // }
        //         // // else if (this.obj.data.name.length < 3)
        //         // // {
        //         // //     this.arr.errors.push('name');
        //         // //     this.arr.errors.push('укажите как минимум три буквы');
        //         // //     return false
        //         // // }
        //         // else if (this.obj.data.name && this.obj.data.name === this.obj.data.surname)
        //         // {
        //         //     this.arr.errors.push('name');
        //         //     this.arr.errors.push('одинаковые имя и фамилия недопустимы');
        //         //     return false
        //         // }
        //         // // Отчество
        //         // else if (this.obj.data.patronymic && this.obj.data.patronymic === this.obj.data.surname)
        //         // {
        //         //     this.arr.errors.push('patronymic');
        //         //     this.arr.errors.push('одинаковые отчество и фамилия недопустимы');
        //         //     return false
        //         // }
        //         // else if (this.obj.data.patronymic && this.obj.data.patronymic === this.obj.data.name)
        //         // {
        //         //     this.arr.errors.push('patronymic');
        //         //     this.arr.errors.push('одинаковые имя и отчество недопустимы');
        //         //     return false
        //         // }
        //         // else if (this.obj.data.patronymic && !cyrillic.test(this.obj.data.patronymic))
        //         // {
        //         //     this.arr.errors.push('patronymic');
        //         //     this.arr.errors.push('допустимы только символы кириллицы');
        //         //     return false
        //         // }
        //         // else if (this.obj.data.patronymic && this.obj.data.patronymic.length < 3)
        //         // {
        //         //     this.arr.errors.push('patronymic');
        //         //     this.arr.errors.push('укажите как минимум три буквы');
        //         //     return false
        //         // }
        //         // // Телефон
        //         // else if (!this.obj.data.phone)
        //         // {
        //         //     this.arr.errors.push('phone');
        //         //     this.arr.errors.push('укажите номер телефона');
        //         //     return false
        //         // }
        //         // else if (this.obj.data.phone.length < 18)
        //         // {
        //         //     this.arr.errors.push('phone');
        //         //     this.arr.errors.push('укажите номер телефона полностью');
        //         //     return false
        //         // }
        //         // Электронная почта
        //         else if (!this.obj.data.email) {
        //             this.arr.errors.push("email");
        //             this.arr.errors.push("укажите адрес электронной почты");
        //             return false;
        //         } else if (!email.test(this.obj.data.email)) {
        //             this.arr.errors.push("email");
        //             this.arr.errors.push(
        //                 "укажите корректный адрес электронной почты"
        //             );
        //             return false;
        //         }
        //     }
        //     // Банковские реквизиты
        //     if (true) {
        //         if (false) {
        //             return false;
        //         }
        //         // БИК
        //         else if (!this.obj.data.bik) {
        //             this.arr.errors.push("bik");
        //             this.arr.errors.push("укажите БИК");
        //             return false;
        //         } else if (this.obj.data.bik.length < 9) {
        //             this.arr.errors.push("bik");
        //             this.arr.errors.push("укажите БИК полностью");
        //             return false;
        //         }
        //         // Номер расчетного счета
        //         else if (!this.obj.data.settlement_account) {
        //             this.arr.errors.push("settlement_account");
        //             this.arr.errors.push("укажите номер расчетного счета");
        //             return false;
        //         } else if (this.obj.data.settlement_account.length < 23) {
        //             this.arr.errors.push("settlement_account");
        //             this.arr.errors.push(
        //                 "укажите номер расчетного счета полностью"
        //             );
        //             return false;
        //         }
        //     }
        //     return true;
        // },
        // действия и ошибки
        openDialog(type = "server_fail") {
            this.str.dialogType = type;
            this.bool.showDialog = true;
        },
        closeDialog() {
            this.bool.showDialog = false;
        },
        // confirmData() {
        //     if (!this.frontValidate()) {
        //         this.bool.showErrors = true;
        //         return;
        //     }

        //     this.fetchCode("button");
        // },
    },
    watch: {
        // validatedFields: {
        //     handler(val) {
        //         this.bool.fieldsAreValidated = this.frontValidate()
        //             ? true
        //             : false;
        //     },
        //     deep: true,
        // },
    },
    computed: {
        // validatedFields() {
        //     const fieldsToValidate = {
        //         personal: JSON.parse(JSON.stringify(this.obj.data)),
        //         reqs: JSON.parse(JSON.stringify(this.obj.data)),
        //     };
        //     return fieldsToValidate;
        // },
    },
    mounted() {
        window.document.head.getElementsByTagName("title")[0].innerHTML = "Перевод в оплачено";
    },
};
</script>

<style scoped lang="scss"></style>
